<template>
  <div @mousedown.stop="videoPreviewStop()">
    <modal
      name="videoSprite.cutting"
      transition="nice-modal-fade"
      :clickToClose="false"
      :width="900"
      :height="600"
      @before-open="beforeOpen"
      @opened="onOpen"
      @closed="onClosed"
    >
      <div class="container">
        <div class="content">
          <div class="video-wrapper">
            <video v-if="sprite.option" :src="getVideoUrl(sprite.option.url)" ref="videoEl"></video>
          </div>
          <div class="controls" v-if="sprite && sprite.video">
            <div class="video-start">{{$util.formatDur2(0)}}</div>
            <div class="bar" id="videoSprite.cuttingBar" ref="bar">
              <my-slider
                :config="sliderConfig"
                :values="sliderValues"
                ref="sliderRef"
              ></my-slider>
            </div>
            <div class="video-end">{{$util.formatDur2(videoProps.duration)}}</div>
            <div class="play-btn" @click.stop="videoPreview();reportPreview()" @mousedown.stop>

            </div>
          </div>
        </div>
        <div class="footer">
          <div class="button button--secondary" @click="clickToClose();reportCancel()">取消</div>
          <div class="button button--primary" @click="setCutDuration();reportConfirm()">确认</div>
        </div>
        <div class="close-btn" @click="clickToClose();reportClose()">
          <i class="icon-video-sprite-cutting-close"></i>
        </div>
        <div class="question">
          <div class="answer">
            <div class="inner">
              单个页面中，可呈现的视频时长不能超过20s
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mySlider from '@/plugins/pluginSlider/nouislider.vue';
import toAnalysisParams from '@/plugins/toAnalysisParams';

export default {
  components: {
    mySlider
  },
  data () {
    const vm = this;
    const f = {to: vm.$util.formatDur2}
    return {
      sprite: {},
      videoProps: {},
      // isShow: false,
      sliderConfig: {
        range: {min: 0, max: 10},
        connect: true,
        step: 0.5,
        margin: 0.5,
        limit: 20,
        behaviour: 'drag',
        tooltips: [f, f]
      },
      sliderValues: [0, 2]
    };
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'SelectSprites_Msg',
      'SpriteOperation',
      'SpriteBeforeSwap',
    ])
  },
  methods: {
    beforeOpen ({params} = {}) {
      this.sprite = params.sprite;
      this.videoProps = params.sprite.video;
      let max = this.videoProps.duration;
      let partNum = Math.floor(max / 0.5);
      let remain = max % 0.5;
      if (remain < 0.25) {
        max = partNum * 0.5;
      } else {
        max = partNum * 0.5 + 0.5;
      }
      max = max.toFixed(1) - 0;

      this.sliderConfig = {
        ...this.sliderConfig,
        range: {min: 0, max}
      };
      this.sliderValues = [
        this.videoProps.startTime,
        this.videoProps.startTime + this.videoProps.cutDuration
      ];
    },
    onOpen () {
      // this.$refs.sliderRef.getMarks()
      // this.isShow = true;
    },
    onClosed () {
      // this.isShow = false;
    },
    getVideoUrl (origin) {
      return this.$handleAssetsUrl(origin);
    },
    clickToClose () {
      this.$modal.hide('videoSprite.cutting');
    },
    videoPreview () {
      this.$refs.sliderRef.videoPreview();
    },
    videoPreviewStop () {
      this.$refs.sliderRef.videoPreviewStop();
    },
    setCutDuration () {
      let startTime = this.$refs.sliderRef.values[0] - 0;
      let endTime = this.$refs.sliderRef.values[1] - 0;
      let cutDuration = endTime - startTime;
      let undo = true;
      if (this.videoProps.startTime === startTime && this.videoProps.cutDuration === cutDuration) {
        undo = false;
      }
      let sceneDur = this.SelectScenes_Msg.duration / 1000;
      let endOffsetTemp = Math.min(this.videoProps.endOffset, sceneDur);
      let offsets = {};
      if (cutDuration > endOffsetTemp - this.videoProps.startOffset) {
        offsets.startOffset = this.videoProps.startOffset;
        offsets.endOffset = Math.min(this.videoProps.startOffset + cutDuration, sceneDur);
      }
      this.sprite.setCutDuration({
        startTime,
        cutDuration,
        ...offsets
      }, undo);
      this.$modal.hide('videoSprite.cutting');
      this.$bus.emit('setCutDuration.done');
      this.$bus.emit('updateEffect_vue', {
        type: 'stay'
      });
    },
    reportConfirm () {
      this.$analysis(toAnalysisParams('video_clipping_panel,click_video_confirm_cut,视频裁剪面板_确定裁剪'))
    },
    reportCancel () {
      this.$analysis(toAnalysisParams('video_clipping_panel,click_video_cancel_cut,视频裁剪面板_取消裁剪'))
    },
    reportClose () {
      this.$analysis(toAnalysisParams('video_clipping_panel,click_video_close_cut,视频裁剪面板_关闭'))
    },
    reportPreview () {
      this.$analysis(toAnalysisParams('video_clipping_panel,click_preview_video,视频裁剪面板_预览视频'))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/_triangle.scss';

  .el-modals .v--modal-overlay {
    background-color: rgba(0, 0, 0, 0.8);
  }

  .container {
    position: relative;
    width: 900px;
    height: 600px;
    background-color: #f0f0f8;
    box-shadow: 0px 0px 4px 0px
      rgba(54, 76, 204, 0.4);
    border-radius: 4px;
  }
  .content {
    width: 900px;
    height: 506px;
    background-color: #000000;

    .video-wrapper {
      width: 100%;
      height: 378px;
      padding-top: 29px;

      & > video {
        width: 100%;
        height: 100%;
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    height: 94px;
    border-radius: 0 0 4px 4px;

    .button {
      width: 120px;
      height: 40px;
      border-radius: 8px;
      text-align: center;

      &--primary {
        background-color: #5778fb;
        border: #5778fb 1px solid;
        &:hover {
          background-color: #5656e8;
          border: #5656e8 1px solid;
        }
      }

      &--secondary {
        margin-right: 93px;
        background-color: #fff;
        border: solid 1px #737596;
        &:hover {
          background-color: #d8d8e9;
          border: solid 1px #d8d8e9;
        }
      }
    }
  }
  .close-btn {
    position: absolute;
    top: 0;
    left: calc(100% + 10px);
    cursor: pointer;
  }

  .controls {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-top: 55px;
    color: #fff;
    & > div {
      display: inline-block;
    }
    & > .bar {
      width: 738px;
      height: 40px;
      background-color: transparent;
    }

    // & .video-start, & .video-end {
    //   padding-left: 1em;
    //   padding-right: 1em
    // }

    & > .play-btn {
      width: 32px;
      height: 28px;
      background-color: #52515b;
      border-radius: 4px;
      cursor: pointer;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAAlklEQVQokaXRvQ1BYRQG4EOrkKjFGCRmUJnACAoqtFYwggEMQKcwh0bcikIi8qhu4uf6+XiT071P855AHzss0UZ8usDZfaaofEJHz9mi+w5lBSjPHPVUBCcMUlGeFZqIErKIqMX3Gf6CopxS/geNUoZYo5Uy+SRl8gUaCp57KCjv0Hss36LLA5ih+grkaIw9Nui8K+d3BV0YLV9O4W5pAAAAAElFTkSuQmCC);
      background-position: center center;
      background-size: 13px 16px;
      background-repeat: no-repeat;
    }
  }

  .question {
    position: absolute;
    right: 34px;
    bottom: 34px;
    width: 18px;
    height: 18px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABqUlEQVQ4jYXUz4tNYRgH8M89XZRoEhqysZgpUlJ+ZGLhx4KFZspMNyFW6NL1B1hO/gFzmSlSFhPdKQvKwkKJjcEskN8SoVw/NhMl8mNxzu2+Xudc3zqd93yf7/m+z/v0PG9pdKQhBxuxH2uwFAneYArncbUlrNYqoBwZdOMUBnPMV2TPPlzDYTxrBZNA2IOHBSYxtuI+1sZG83AX86MfxrELOzCMV0FsFm6P1Sd6aR/tAroC0S9swK2Au4Lj2YYrA/4ylidYjW1RJscyk4OYxjfU8QP92UYtLBurTwyWRkca49gTGZWy9++IX4QmPmJBwF8vY51/cRGzI+4rPmXruVGsp4zFOUY7o++32IyfOCktdIiusvYxitCU9s80TuBIjqaU4MN/jAYyk9M4WqD5kuBOB5PvmJT22YEOupeJdCSKMBOP8KSDBs4kuCFtsjw8wCHsxrsCTbNaq5xrdfYQnmNGJHqKm9n6PZbkGA3QHpHX6MvJbAiXMEc6ATG2V2uVSf6e/imskhY3RD+2RNxjbBLcS/F9dA/rpTXZi14slPbaZ7xAA2fj1P4Arx9XAxnMeVkAAAAASUVORK5CYII=);

    & > .answer {
      display: none;
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translate(-50%, 0);
      height: 82px;

      & > .inner {
        position: relative;
        width: 180px;
        height: 70px;
        padding: 20px;
        background-color: rgba(#000000, .7);
        color: #fff;
        border-radius: 4px;
        &::before {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translate(-50%, 0);
          @include triangle(bottom, 8px, 8px, rgba(#000000, .7))
        }
      }
    }
    &:hover > .answer {
      display: initial;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/emodal/videoSprite/cutVideo.vue